const ResultsTable = ({ data }) => {
  if (!data || typeof data !== 'object') {
    return null
  }

  return (
    <table className='table table-bordered table-sm mt-2'>
      <tbody>
        {Object.entries(data).map(([key, value]) => (
          <tr key={key}>
            <td className='fw-bold align-top'>{key}</td>
            <td>
              {typeof value === 'object' && value !== null ? (
                Array.isArray(value) ? (
                  <ul className='mb-0 ps-3'>
                    {value.map((v, i) => (
                      <li key={i} className='list-unstyled'>
                        {typeof v === 'object' ? <ResultsTable data={v} /> : String(v)}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <ResultsTable data={value} />
                )
              ) : (
                String(value)
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  )
}

export default ResultsTable
